import  React, {useEffect, useState} from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CancelIcon from '@mui/icons-material/Cancel';

import axios from 'axios';
import cookie from "react-cookies";
import DatePicker from "react-datepicker";
import { MOBILE_WEB_BASE_URL } from '../../unified/webbase';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: 24,
};

export default function ResellerDiscount({open, handleClose}) {
     
     

    const token = cookie.load("token")
  
    const [dspAirtime, setdspAirtime] = useState(0)
    const [dspCable, setdspCable] = useState(0)
    const [dspData, setdspData] = useState(0)
    const [dspElectricity, setdspElectricity] = useState(0)
    const [dspInternet, setdspInternet] = useState(0)
    const [dspJamb, setdspJamb] = useState(0)
    const [dspWaec, setdspWaec] = useState(0)

    const setThresholdValue = (e) =>{
        e.preventDefault()
       
        const id = toast.loading("Please wait...");
    const valuess = {
        "dspAirtime":dspAirtime,
        "dspCable": dspCable,
        "dspData": dspData,
        "dspElectricity": dspElectricity,
        "dspInternet": dspInternet,
        "dspJamb": dspJamb,
        "dspWaec": dspWaec
       
    }

    axios
    .post(MOBILE_WEB_BASE_URL + "/manage-discount-reseller", valuess,  {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if (res.data.status === "2000") {
        toast.update(id, {
          render: res.data.description,
          type: "success",
          isLoading: false,
        });
        setTimeout(() => {
        //   toast.dismiss(id);
          window.location.href ="/manage-commission";
        }, 2000);
      } else {
        console.log(res);
        toast.update(id, {
          render: res.data.description,
          type: "error",
          isLoading: false,
        });
      }
    })
    .catch((err) => {
      toast.update(id, {
        render: err,
        type: "error",
        isLoading: false,
      });
    });
}

useEffect(() =>{
    axios
    .get(MOBILE_WEB_BASE_URL + `/get-discount-user`, {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if(res.data.status === "2000" && res.data.data !== null ){
    //    setDsp(res.data.data.dsp)
    //    setPromDsp(res.data.data.promoDsp)
      }
    })
    .catch((err) => { console.log(MOBILE_WEB_BASE_URL + " " + err); })
},[token])


  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=' rounded-lg  p-4 pt-10'> 
          
            <div className=' '>
           
                <div className=' d-flex justify-content-end'>
                   
                    <div>
                    <CancelIcon onClick={handleClose} className=' text-black cursor-pointer text-[38px]' fontSize="large"/>
                    
                    </div>
                </div>
                <h5 className=' px-4 '> Reseller discount</h5>
                <form onSubmit={setThresholdValue} className="row">
       <div className="row">
       <div className="col-3"></div>
       <div className="col-12">
       
                <div className=' my-2'>
                <label className=' mb-2'>Airtime discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspAirtime}
                    onChange={(e) => setdspAirtime(e.target.value)}
                    placeholder="Set Airtime discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Cable discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspCable}
                    onChange={(e) => setdspCable(e.target.value)}
                    placeholder="Set Cable discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Data discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspData}
                    onChange={(e) => setdspData(e.target.value)}
                    placeholder="Set Data discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Electricity discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspElectricity}
                    onChange={(e) => setdspElectricity(e.target.value)}
                    placeholder="Set Electricity discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Internet discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspInternet}
                    onChange={(e) => setdspInternet(e.target.value)}
                    placeholder="Set Internet discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Jamb discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspJamb}
                    onChange={(e) => setdspJamb(e.target.value)}
                    placeholder="Set Jamb discount"
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'>Weac discount:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspWaec}
                    onChange={(e) => setdspWaec(e.target.value)}
                    placeholder="Set Waec discount"
                  />
                </div>
                
                        </div>
                        <div className="col-3"></div>
                        </div>
                        <div className=' row'>
                        <div className="col-8"></div>
                        <div className="col-3 my-3">
                        <div className="ms-auto">
                                <div className="btn-group">
                                <button type="submit" 
                                onClick={setThresholdValue}
                                className="btn btn-primary">
                                    Submit
                                </button>
                                </div>
                            </div>
                        </div>
                        </div>
                        </form>
               
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}